import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card, CardBody, Row, Col, Button, Input, Label, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Alert, Nav, NavLink, NavItem, TabContent, TabPane } from 'reactstrap';

import { Eye, EyeOff } from 'react-feather';

import ReactTooltip from 'react-tooltip';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  getCompanyApiKey,
  getLinkedAPIs,
  updateLinkedAPI,
  addLinkedAPI,
  removeLinkedAPI,
  connectShopifyApp,
  testAndSaveWoocommerce,
} from '../../../../actions/company';

import {
  getLinkedCompanyUsers,
  createLinkedCompanyUser,
  deleteLinkedCompanyUser,
  createLinkedCompanyUserAdmin,
} from '../../../../actions/users';

import {
  getAPITooltips,
} from '../../../../actions/contentManagement';

import ShopifyNewConnection, { isNewRouteAccess } from './ShopifyNewConnection';
import WooConnection from './WooConnection';
import {
  colors,
  headingStyle,
  inputStyle,
  StepCard,
  FieldRow,
  Field,
  PrimaryButton,
} from './ConnectionParts';

class LinkedCompaniesAPIs extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    contactPage: PropTypes.shape(),
    apiTooltips: PropTypes.shape(),
    fetchAPITooltips: PropTypes.func.isRequired,
    changeActiveAPI: PropTypes.func.isRequired,
    fetchLinkedAPIs: PropTypes.func.isRequired,
    linkedAPIupdate: PropTypes.func.isRequired,
    linkedAPIAdd: PropTypes.func.isRequired,
    linkedAPIRemove: PropTypes.func.isRequired,
    connectShopify: PropTypes.func.isRequired,
    wooTestAndSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    contactPage: {},
    apiTooltips: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      copiedSuccess: false,
      show: false,
      show2: false,
      showNoPermission: false,
      dontShowPage: false,
      hadExistingData: false,
      showConfirmModal: false,
      showConfirmModalShown: false,
      originalShopify: {},
      originalWoocommerce: {},
      hasOriginal: false,
    };
  }

  componentDidMount() {
    const { adminViewAsCompany, fetchCompanyApiKey, user, getShopifyAPI, getWoocommerceAPI, fetchAPITooltips, getActiveAPI, fetchLinkedAPIs, fetchLinkedCompanyUsers } = this.props;

    fetchAPITooltips();
    // The Content Management "API page" text is no longer shown here: the connection steps carry their own instructions

    // Partner shop logins may not read the API key
    if (user && user.company && user.role !== 'linkedCompanyUser') {
      fetchCompanyApiKey(user.company);

      if (!user.linkedCompaniesAccount) {

      } else {
       // fetchLinkedAPIs(user.company);
      //  fetchLinkedCompanyUsers(user.company);
      }
    }

    let showPageAdmin = false;

    if (adminViewAsCompany && user.roleClass === 'admin') {
      if (user.role === 'admin') {
        this.setState({ showNoPermission: false, dontShowPage: false });
        showPageAdmin = true;
      } else {
        const { adminsRoles } = this.props;

        if (adminsRoles && adminsRoles[user.role] && adminsRoles[user.role].permissions && adminsRoles[user.role].permissions.companyAccess) {
          this.setState({ showNoPermission: false, dontShowPage: false });
          showPageAdmin = true;
        } else {
          this.setState({ showNoPermission: false, dontShowPage: true });
        }
      }

      if (showPageAdmin && adminViewAsCompany) {
        fetchCompanyApiKey(adminViewAsCompany);

       // fetchLinkedAPIs(adminViewAsCompany);
      //  fetchLinkedCompanyUsers(adminViewAsCompany);
      }

    } else if (user.company) {
      const { roles } = this.props;

      if (user.role === 'teamOwner') {
        this.setState({ showNoPermission: false });
      } else {
        if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.api) {
          if (roles[user.role].permissions.api === 2) {
            this.setState({ showNoPermission: false, dontShowPage: false });
          } else {
            this.setState({ showNoPermission: false, dontShowPage: false });
          }
        } else {
          this.setState({ showNoPermission: false, dontShowPage: true });
        }
      }
    }
  }

  copyToClipboard = () => {
    const { apiKey } = this.props;

    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      this.setState({ copiedSuccess: true });
    }
  }

  toggleShow = () => {
    this.setState((prevState) => ({ show: !prevState.show }));
  }

  toggleShow2 = () => {
    this.setState((prevState) => ({ show2: !prevState.show2 }));
  }

  handleChangeAPI = (e) => {
    e.preventDefault();
    const { showConfirmModalShown, hadExistingData } = this.state;

    if (hadExistingData && !showConfirmModalShown) {
      this.setState({ showConfirmModalShown: true, showConfirmModal: true });
    }

    if (e.target && e.target.name) {
      const { name, value } = e.target;

      this.setState({ [name]: value, changeAPIError: false });
    }
  }

  handleChangeEditData = (e) => {
    e.preventDefault();

    if (e.target && e.target.name) {
      const { name, value } = e.target;

      if (name === 'editManualUserName') {
        this.setState({ editManualUserName: value });

        this.setState((prevState) => ({
          editData: {
            ...prevState.editData,
            linkedUserName: value,
          }
        }));
      } else {
        this.setState((prevState) => ({
          editData: {
            ...prevState.editData,
            [name]: value,
          }
        }));
      }
    }
  }

  handleChange = (e) => {
    e.preventDefault();

    if (e.target && e.target.name) {
      const { name, value } = e.target;

      this.setState({ [name]: value });
    }
  }

  handleChangeType = (e) => {
    e.preventDefault();

    if (e.target && e.target.name) {
      const { name } = e.target;

      this.setState({ editType: name });
    }
  }

  openAddModal = () => {
    this.setState({
      editModal: false,
      addModal: true,
      removeModal: false,
      editName: null,
      editEmail: null,
      editType: 'shopify',
      editData: null,
      editPassword: null,
      editManualUserName: null,
      linkedShopifyLegacy: false,
      modalError: null,
    });
  }

  openEditModal = (id) => {
    const { linkedCompaniesAPIs } = this.props;

    if (linkedCompaniesAPIs[id]) {
      this.setState({
        editModal: true,
        addModal: false,
        removeModal: false,
        editId: id,
        editName: linkedCompaniesAPIs[id].type === 'manual' ? linkedCompaniesAPIs[id].companyName : linkedCompaniesAPIs[id].name,
        editEmail: linkedCompaniesAPIs[id].email,
        editType: linkedCompaniesAPIs[id].type,
        editData: linkedCompaniesAPIs[id].apiData,
        editManualUserName: linkedCompaniesAPIs[id].type === 'manual' ? linkedCompaniesAPIs[id].name : null,
        linkedShopifyLegacy: false,
        linkedShopifyNew: false,
        modalError: null,
      });
    }
  }

  openRemoveModal = (id) => {
    const { linkedCompaniesAPIs } = this.props;

    if (linkedCompaniesAPIs[id]) {
      this.setState({
        editModal: false,
        addModal: false,
        removeModal: true,
        removeId: id,
      });
    }
  }

  closeModal = () => {
    this.setState({
      editModal: false,
      addModal: false,
      removeModal: false,
      editId: null,
      removeId: null,
      editName: null,
      editEmail: null,
      editType: null,
      editData: null,
      editPassword: null,
      editManualUserName: null,
      linkedShopifyLegacy: false,
      linkedShopifyNew: false,
      modalError: null,
    });
  }

  // Shopify, new connection (the shop's own Dev Dashboard app): shopifyConnectApp tests and saves the linked shop.
  // Add: with the business name and email typed above; edit: replaces that linked shop's details.
  connectLinkedShopify = ({ shopName, clientId, clientSecret }) => {
    const { connectShopify, user, adminViewAsCompany } = this.props;
    const { editModal, editId, editName, editEmail } = this.state;
    const companyId = (user && user.company) ? user.company : adminViewAsCompany;

    if (editModal) {
      return connectShopify({ companyId, shopName, clientId, clientSecret, linked: true, linkedId: editId });
    }

    return connectShopify({ companyId, shopName, clientId, clientSecret, linked: true, linkedName: editName, linkedEmail: editEmail });
  }

  validateLinkedShopify = () => {
    const { editModal, editName, editEmail } = this.state;

    if (!editModal && (!editName || !String(editName).trim() || !editEmail || !String(editEmail).trim())) {
      return 'Please fill in the business name and support email first.';
    }

    return null;
  }

  linkedShopifyConnected = () => {
    this.closeModal();
  }

  // WooCommerce partner shop: wooTestAndSave tests the key and saves the partner shop only when every check passes
  // (add: with the business name and email above; edit: replaces that partner shop's key, and its name and email)
  connectLinkedWoo = ({ shopUrl, consumerKey, consumerSecret }) => {
    const { wooTestAndSave, user, adminViewAsCompany } = this.props;
    const { editModal, editId, editName, editEmail } = this.state;
    const companyId = (user && user.company) ? user.company : adminViewAsCompany;
    const linkedName = String(editName || '').trim();
    const linkedEmail = String(editEmail || '').trim();

    if (editModal) {
      return wooTestAndSave({ companyId, shopUrl, consumerKey, consumerSecret, linked: true, linkedId: editId, linkedName, linkedEmail });
    }

    return wooTestAndSave({ companyId, shopUrl, consumerKey, consumerSecret, linked: true, linkedName, linkedEmail });
  }

  validateLinkedPartner = () => {
    const { editName, editEmail } = this.state;

    if (!editName || !String(editName).trim() || !editEmail || !String(editEmail).trim()) {
      return 'Please fill in the business name and support email first.';
    }

    return null;
  }

  // Manual partner shop: the same saves as the old Confirm button (confirmAddAPI / confirmEditAPI)
  submitManualAdd = () => {
    this.setState({ modalError: null });
    this.confirmAddAPI();
  }

  submitManualEdit = () => {
    this.setState({ modalError: null });
    this.confirmEditAPI();
  }

  renderManualPartner(isEdit) {
    const { show, editPassword, editManualUserName, modalSaveSpinner, modalError } = this.state;

    return (
      <>
        <StepCard number={1}>
          <h2 style={headingStyle}>A voucher portal login for this partner</h2>
          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: colors.muted }}>
            Choose Manual if this partner doesn't sell through Shopify or WooCommerce, or takes orders in person, by phone or by email. This creates an online voucher portal login for the partner, where they check and redeem each Steppr code manually.
          </p>
          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: colors.muted }}>
            We will email the portal login details to the support email above.
          </p>
        </StepCard>

        <StepCard number={2}>
          <h2 style={headingStyle}>{isEdit ? 'The portal login' : 'Choose the portal login'}</h2>
          <FieldRow>
            <Field id="editManualUserName" label="Name">
              <Input
                name="editManualUserName"
                id="editManualUserName"
                type="text"
                placeholder="Name"
                value={editManualUserName || ''}
                style={inputStyle}
                onChange={this.handleChangeEditData}
              />
            </Field>
            <Field id="editPassword" label="Password">
              <div style={{ position: 'relative' }}>
                <Input
                  name="editPassword"
                  id="editPassword"
                  type={show ? 'text' : 'password'}
                  placeholder="Password"
                  autoComplete="new-password"
                  value={editPassword || ''}
                  style={{ ...inputStyle, paddingRight: 44 }}
                  onChange={this.handleChange}
                />
                {show ? (
                  <Eye style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={this.toggleShow} />
                ) : (
                  <EyeOff style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={this.toggleShow} />
                )}
              </div>
            </Field>
          </FieldRow>
        </StepCard>

        <StepCard number={3}>
          <h2 style={headingStyle}>{isEdit ? 'Save the changes' : 'Create the portal login'}</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
            <PrimaryButton onClick={isEdit ? this.submitManualEdit : this.submitManualAdd} busy={!!modalSaveSpinner && !modalError}>
              {isEdit ? 'Save changes' : 'Create portal login'}
            </PrimaryButton>
            {isEdit ? null : (<span style={{ fontSize: 14, color: colors.muted }}>The login details are emailed to the support email above.</span>)}
          </div>
          {modalError ? (
            <Alert color="danger" style={{ margin: 0 }}>{modalError === 'password missing' ? 'Please enter a password for the portal login.' : modalError}</Alert>
          ) : null}
        </StepCard>
      </>
    );
  }

  useLinkedShopifyLegacy = () => {
    this.setState({ linkedShopifyLegacy: true });
  }

  useLinkedShopifyNew = () => {
    this.setState({ linkedShopifyNew: true });
  }

  // A save that fails (e.g. the support email already has a Steppr login) stops the spinner and says why
  saveFailed = (err) => {
    const code = err && typeof err === 'object' ? err.code : null;
    let message = 'This didn\'t complete. Please refresh the page to see what was saved, then try again if needed.';

    if (err === 'email address already used' || code === 'auth/email-already-exists') {
      message = 'This email already has a Steppr login. Please use a different support email for this partner.';
    } else if (code === 'auth/invalid-email') {
      message = 'Please enter a valid support email.';
    } else if (code === 'auth/invalid-password') {
      message = 'Please choose a password of at least 6 characters.';
    } else if (err === 'no email') {
      message = 'Please fill in the support email.';
    } else if (err === 'no name') {
      message = 'Please fill in the business name and the portal login name.';
    }

    this.setState({ modalSaveSpinner: null, modalError: message });
  }

  confirmAddAPI = () => {
    const { linkedAPIAdd, createLinkedUser, createLinkedUserAdmin, user, fetchLinkedAPIs, adminViewAsCompany } = this.props;
    const {
      editModal,
      addModal,
      editName,
      editEmail,
      editPassword,
      editManualUserName,
    //  confirmPassword,
      editType,
      editData,
    } = this.state;

    this.setState({ modalSaveSpinner: true });

    if (user && user.company) {
      if (editType === 'manual') {
        if (editPassword) {
          // companyId, email, password, name
          createLinkedUser(user.company, editEmail, editPassword, editManualUserName, editName).then((res) => {
            console.log('createLinkedUser res', res);

          //  fetchLinkedAPIs(user.company);

            this.setState({ addModal: null, editId: null, modalSaveSpinner: null });
          }).catch(this.saveFailed);
        } else {
          this.setState({ modalError: "password missing" });
        }
      } else {
        linkedAPIAdd(user.company, editName, editEmail, editType, editData).then((res) => {
          console.log('linkedAPIAdd res', res);

        //  fetchLinkedAPIs(user.company);

          this.setState({ addModal: null, editId: null, modalSaveSpinner: null });
        }).catch(this.saveFailed);
      }
      // linkedAPIAdd(user.company, editName, editEmail, editType, editData);
    } else if (adminViewAsCompany) {
      if (editType === 'manual') {
        if (editPassword) {
          createLinkedUserAdmin(adminViewAsCompany, editEmail, editPassword, editManualUserName, editName).then((res) => {
            console.log('createLinkedUser res', res);

            this.setState({ addModal: null, editId: null, modalSaveSpinner: null });
          }).catch(this.saveFailed);
        } else {
          this.setState({ modalError: "password missing" });
        }
      } else {
        linkedAPIAdd(adminViewAsCompany, editName, editEmail, editType, editData).then((res) => {
          console.log('linkedAPIAdd res', res);

          this.setState({ addModal: null, editId: null, modalSaveSpinner: null });
        }).catch(this.saveFailed);
      }
    }
  }

  confirmEditAPI = () => {
    const { linkedAPIUpdate, createLinkedUser, user, fetchLinkedAPIs, adminViewAsCompany } = this.props;
    const {
    //  editModal,
    //  addModal,
      editId,
      editName,
      editEmail,
      editPassword,
      editManualUserName,
    //  confirmPassword,
      editType,
      editData,
    } = this.state;

    this.setState({ modalSaveSpinner: true });

    if (user && user.company) {
      if (editType === 'manual') {
      //  if (editPassword === confirmPassword) {
     //   this.setState({ editModal: null, editId: null, modalSaveSpinner: null });
        //  createLinkedUser(user.company, editId, editName, editEmail, editPassword);
      //  } else {
      //    this.setState({ modalError: "password don't match" });
      //  }
        linkedAPIUpdate(user.company, editId, editName, editEmail, editType, editData, editManualUserName).then((res) => {
          console.log('linkedAPIUpdate res', res);

        //  fetchLinkedAPIs(user.company);

          this.setState({ editModal: null, editId: null, modalSaveSpinner: null });
        }).catch(this.saveFailed);
      } else {
        linkedAPIUpdate(user.company, editId, editName, editEmail, editType, editData, null).then((res) => {
          console.log('linkedAPIUpdate res', res);

        //  fetchLinkedAPIs(user.company);

          this.setState({ editModal: null, editId: null, modalSaveSpinner: null });
        }).catch(this.saveFailed);
      }
    } else if (adminViewAsCompany) {
      if (editType === 'manual') {
        linkedAPIUpdate(adminViewAsCompany, editId, editName, editEmail, editType, editData, editManualUserName).then((res) => {
          console.log('linkedAPIUpdate res', res);

          this.setState({ editModal: null, editId: null, modalSaveSpinner: null });
        }).catch(this.saveFailed);
      } else {
        linkedAPIUpdate(adminViewAsCompany, editId, editName, editEmail, editType, editData, null).then((res) => {
          console.log('linkedAPIUpdate res', res);

          this.setState({ editModal: null, editId: null, modalSaveSpinner: null });
        }).catch(this.saveFailed);
      }
    }
  }

  confirmRemoveAPI = () => {
    const { linkedAPIRemove, user, adminViewAsCompany } = this.props;
    const {
      removeId,
    } = this.state;

    this.setState({ modalSaveSpinner: true });

    console.log('confirmRemoveAPI', removeId);

    if (user && user.company) {
      linkedAPIRemove(user.company, removeId).then((res) => {
        console.log('linkedAPIRemove res', res);

        this.setState({ removeModal: null, removeId: null, modalSaveSpinner: null });
      }).catch(this.saveFailed);
    } else if (adminViewAsCompany) {
      linkedAPIRemove(adminViewAsCompany, removeId).then((res) => {
        console.log('linkedAPIRemove res', res);

        this.setState({ removeModal: null, removeId: null, modalSaveSpinner: null });
      }).catch(this.saveFailed);
    }
  }

  render() {
    const { linkedCompaniesAPIs } = this.props;
    const {
      show,
      showConfirmModal,
      hasOriginal,
      editModal,
      removeModal,
      addModal,
      editId,
      editName,
      editEmail,
    //  confirmPassword,
      editType,
      editData,
      modalSaveSpinner,
      modalError,
      linkedShopifyLegacy,
      linkedShopifyNew,
    } = this.state;

    // Adding a Shopify shop: the new connection (own Dev Dashboard app) unless the user chose an older app's token.
    // Editing: a new-route shop, or a legacy shop after "Set up a new connection", uses the new connection; other
    // legacy shops keep today's fields.
    const addShopifyNew = editType === 'shopify' && !linkedShopifyLegacy;
    const editShopifyNew = editType === 'shopify' && (isNewRouteAccess(editData) || linkedShopifyNew);

    return (
      <Card>
        <CardBody>
          <div className="company-api">
            {(linkedCompaniesAPIs && Object.keys(linkedCompaniesAPIs).length) ? (
              <>
                <div style={{ fontSize: 28, marginBottom: 15 }}>
                  Your connected businesses
                </div>
                {linkedCompaniesAPIs ? (Object.keys(linkedCompaniesAPIs).map((key) => (
                  <>
                    {linkedCompaniesAPIs[key] ? (
                      <Row style={{ marginBottom: 5 }}>
                        <Col xs="1">
                          <div className={`${(linkedCompaniesAPIs[key].valid) ? 'status-indicators-active' : 'status-indicators-inactive'}`} />
                        </Col>
                        <Col xs="2">
                          {(linkedCompaniesAPIs[key].type === 'manual' && linkedCompaniesAPIs[key].companyName) ? linkedCompaniesAPIs[key].companyName : linkedCompaniesAPIs[key].name}
                        </Col>
                        <Col xs="3">
                          {linkedCompaniesAPIs[key].email}
                        </Col>
                        <Col xs="2">
                          <Button color="link" onClick={() => this.openEditModal(key)}>
                            {linkedCompaniesAPIs[key].type}
                          </Button>
                        </Col>
                        <Col xs="2">
                          <Button color="danger" style={{ opacity: '0.65', paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4, borderRadius: 25 }} onClick={() => this.openRemoveModal(key)}>
                            Remove
                          </Button>
                        </Col>
                      </Row>
                    ) : (null)}
                  </>
                ))) : (null)}
                <Row>
                  <Col xs="6" />
                  <Col xs="2">
                    <Button onClick={this.openAddModal} style={{ marginLeft: 25 }}>
                      +
                    </Button>
              </Col>
              <Col xs="4" />
                </Row>
              </>
            ) : (
              <Row>
                <Col xs="12">
                    <Button onClick={this.openAddModal} style={{ padding: '15px 25px 20px 25px', fontSize: 22, color: '#7f8fa4' }}>
                      <span style={{ fontWeight: 900, fontSize: 28 }}>+</span> New website connection
                  </Button>
                </Col>
              </Row>
            )}

            <Modal size="lg" isOpen={addModal} toggle={this.closeModal}>
              <ModalHeader toggle={this.closeModal}>
                Add company
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xs="12" style={{ marginBottom: 15 }}>
                    <Input
                      name="editName"
                      id="editName"
                      type="text"
                      placeholder="Business name"
                      value={editName}
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" style={{ marginBottom: 15 }}>
                    <Input
                      name="editEmail"
                      id="editEmail"
                      type="text"
                      placeholder="Support email"
                      value={editEmail}
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" style={{ marginBottom: 30 }}>
                    <Row>
                      <Col xs="4">
                        <Button
                          name="shopify"
                          id="shopify"
                          color={'secondary'}
                          value={'shopify'}
                          onClick={this.handleChangeType}
                          className={`basic-information-middle-companyType-button ${editType === 'shopify' ? 'basic-information-middle-companyType-button-active' : ''}`}
                        >
                          Shopify
                        </Button>
                      </Col>
                      <Col xs="4">
                        <Button
                          name="woocommerce"
                          id="woocommerce"
                          color={'secondary'}
                        value={'woocommerce'}
                          onClick={this.handleChangeType}
                          className={`basic-information-middle-companyType-button ${editType === 'woocommerce' ? 'basic-information-middle-companyType-button-active' : ''}`}
                        >
                          Woocommerce
                        </Button>
                      </Col>
                      <Col xs="4">
                        <Button
                          name="manual"
                          id="manual"
                          color={'secondary'}
                          value={'manual'}
                          onClick={this.handleChangeType}
                          className={`basic-information-middle-companyType-button ${editType === 'manual' ? 'basic-information-middle-companyType-button-active' : ''}`}
                        >
                          Manual
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" >
                    {addShopifyNew ? (
                      <>
                        <ShopifyNewConnection
                          compact
                          connect={this.connectLinkedShopify}
                          onConnected={this.linkedShopifyConnected}
                          validate={this.validateLinkedShopify}
                        />
                        <Button color="link" style={{ padding: 0 }} onClick={this.useLinkedShopifyLegacy}>
                          Use an access token from an older Shopify app instead
                        </Button>
                      </>
                    ) : (null)}

                    {(editType === 'shopify' && !addShopifyNew) ? (
                      <>
                        <FormGroup style={{ position: 'relative', marginBottom: 10 }}>
                        <Label for="shopifyAPIAccessToken">
                          Access token<div className="mandatory">*</div>
                        </Label>
                        <Input
                          name="shopifyAPIAccessToken"
                          id="shopifyAPIAccessToken"
                          type={show ? 'text' : 'password'}
                            placeholder="Access token"
                            value={editData ? editData.shopifyAPIAccessToken : ''}
                          style={{ width: '100%' }}
                            onChange={this.handleChangeEditData}
                        />
                        {show ? (
                          <Eye style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                        ) : (
                          <EyeOff style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                        )}
                        </FormGroup>
                        <FormGroup style={{ position: 'relative', marginBottom: 10 }}>
                        <Label for="shopifyAPIShopName">
                          Web address<div className="mandatory">*</div>
                        </Label>
                        <Input
                          name="shopifyAPIShopName"
                          id="shopifyAPIShopName"
                          type="text"
                            placeholder="Web address"
                              value={editData ? editData.shopifyAPIShopName : ''}
                          style={{ width: '100%' }}
                              onChange={this.handleChangeEditData}
                        />
                        </FormGroup>
                      </>
                    ):(null)}

                    {editType === 'woocommerce' ? (
                      <WooConnection
                        partner
                        connect={this.connectLinkedWoo}
                        onConnected={this.linkedShopifyConnected}
                        validate={this.validateLinkedPartner}
                      />
                    ) : (null)}

                    {editType === 'manual' ? this.renderManualPartner(false) : (null)}
                  </Col>
                </Row>
              </ModalBody>
              {(addShopifyNew || editType === 'woocommerce' || editType === 'manual') ? (null) : (
              <ModalFooter>
                {modalError ? (<Alert color="danger" style={{ margin: 0, marginRight: 'auto' }}>{modalError}</Alert>) : null}
                <Button color="primary" onClick={this.confirmAddAPI}>
                  Confirm
                  {(modalSaveSpinner) ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                  ) : (null)}
                </Button>
              </ModalFooter>
              )}
            </Modal>


            <Modal size="lg" isOpen={editModal} toggle={this.closeModal}>
              <ModalHeader toggle={this.closeModal}>
                Edit
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xs="12" style={{ marginBottom: 15 }}>
                    <Input
                      name="editName"
                      id="editName"
                      type="text"
                      placeholder="Business name"
                      disabled={editType !== 'woocommerce'}
                      value={editName}
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" style={{ marginBottom: 15 }}>
                    <Input
                      name="editEmail"
                      id="editEmail"
                      type="text"
                      placeholder="Support email"
                      disabled={editType !== 'woocommerce'}
                      value={editEmail}
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" style={{ marginBottom: 30 }}>
                    <Row>
                      <Col xs="4">
                        <Button
                          name="shopify"
                          id="shopify"
                          color={'secondary'}
                          value={'shopify'}
                          disabled
                          onClick={this.handleChangeType}
                          className={`basic-information-middle-companyType-button ${editType === 'shopify' ? 'basic-information-middle-companyType-button-active' : ''}`}
                        >
                          Shopify
                        </Button>
                      </Col>
                      <Col xs="4">
                        <Button
                          name="woocommerce"
                          id="woocommerce"
                          color={'secondary'}
                          value={'woocommerce'}
                          disabled
                          onClick={this.handleChangeType}
                          className={`basic-information-middle-companyType-button ${editType === 'woocommerce' ? 'basic-information-middle-companyType-button-active' : ''}`}
                        >
                          Woocommerce
                        </Button>
                      </Col>
                      <Col xs="4">
                        <Button
                          name="manual"
                          id="manual"
                          color={'secondary'}
                          value={'manual'}
                          disabled
                          onClick={this.handleChangeType}
                          className={`basic-information-middle-companyType-button ${editType === 'manual' ? 'basic-information-middle-companyType-button-active' : ''}`}
                        >
                          Manual
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" >
                    {editShopifyNew ? (
                      <>
                        {(editData && (editData.shopName || editData.shopifyAPIShopName)) ? (
                          <p style={{ fontSize: 15, marginBottom: 15 }}>
                            Current shop: {editData.shopName || editData.shopifyAPIShopName}. Enter all three details again; the current connection stays active until the new details pass the test.
                          </p>
                        ) : (null)}
                        <ShopifyNewConnection
                          compact
                          connect={this.connectLinkedShopify}
                          onConnected={this.linkedShopifyConnected}
                        />
                      </>
                    ) : (null)}

                    {(editType === 'shopify' && !editShopifyNew) ? (
                      <>
                        <FormGroup style={{ position: 'relative', marginBottom: 10 }}>
                          <Label for="shopifyAPIAccessToken">
                            Access token<div className="mandatory">*</div>
                          </Label>
                          <Input
                            name="shopifyAPIAccessToken"
                            id="shopifyAPIAccessToken"
                            type={show ? 'text' : 'password'}
                            placeholder=" Access token"
                            value={editData ? editData.shopifyAPIAccessToken : ''}
                            style={{ width: '100%' }}
                            onChange={this.handleChangeEditData}
                          />
                          {show ? (
                            <Eye style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                          ) : (
                            <EyeOff style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                          )}
                        </FormGroup>
                        <FormGroup style={{ position: 'relative', marginBottom: 10 }}>
                          <Label for="shopifyAPIShopName">
                            Web address<div className="mandatory">*</div>
                          </Label>
                          <Input
                            name="shopifyAPIShopName"
                            id="shopifyAPIShopName"
                            type="text"
                            placeholder="Web address"
                            value={editData ? editData.shopifyAPIShopName : ''}
                            style={{ width: '100%' }}
                            onChange={this.handleChangeEditData}
                          />
                        </FormGroup>
                      </>
                    ) : (null)}

                    {editType === 'woocommerce' ? (
                      <WooConnection
                        partner
                        key={editId || 'edit'}
                        initialShopUrl={(editData && editData.shopUrl) || ''}
                        connect={this.connectLinkedWoo}
                        onConnected={this.linkedShopifyConnected}
                        validate={this.validateLinkedPartner}
                      />
                    ) : (null)}

                    {editType === 'manual' ? this.renderManualPartner(true) : (null)}
                  </Col>
                </Row>
              </ModalBody>
              {(editShopifyNew || editType === 'woocommerce' || editType === 'manual') ? (null) : (
              <ModalFooter>
                {modalError ? (<Alert color="danger" style={{ margin: 0, marginRight: 'auto' }}>{modalError}</Alert>) : null}
                {(editType === 'shopify') ? (
                  <Button color="link" onClick={this.useLinkedShopifyNew} style={{ marginRight: 'auto' }}>
                    Set up a new connection
                  </Button>
                ) : (null)}
                <Button color="primary" onClick={this.confirmEditAPI}>
                  Confirm
                  {(modalSaveSpinner) ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                  ) : (null)}
                </Button>
              </ModalFooter>
              )}
            </Modal>

            <Modal size="sm" isOpen={removeModal} toggle={this.closeModal}>
              <ModalHeader toggle={this.closeModal}>
                Are you sure?
              </ModalHeader>
              <ModalFooter>
                {modalError ? (<Alert color="danger" style={{ margin: 0, marginRight: 'auto' }}>{modalError}</Alert>) : null}
                <Button color="primary" onClick={this.confirmRemoveAPI}>
                  Yes
                  {(modalSaveSpinner) ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                  ) : (null)}
                </Button>
                <Button color="secondary" onClick={this.closeModal}>
                  No
                </Button>
              </ModalFooter>
            </Modal>

            {/* <TabContent activeTab={activeAPI} style={{ padding: 0, background: 'transparent' }}>
              <TabPane tabId="shopify">
                {!!changeAPIError ? (<Alert color="danger"> {changeAPIError} </Alert>) : null}

                <Row style={{ marginTop: 5 }}>
                  <Col>
                    <div className="company-api-input" style={{ position: 'relative', width: '35%', marginRight: 10 }}>

                      <Label for="shopifyAPIAccessToken">
                        Access token<div className="mandatory">*</div>
                      </Label>
                      <Input
                        name="shopifyAPIAccessToken"
                        id="shopifyAPIAccessToken"
                        type={show ? 'text' : 'password'}
                        placeholder=""
                        value={shopifyAPIAccessToken}
                        style={{ width: '100%' }}
                        onChange={this.handleChangeAPI}
                      >
                        {apiKey || null}
                      </Input>
                      {show ? (
                        <Eye style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                      ) : (
                        <EyeOff style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                      )}
                    </div>

                    <div className="company-api-input" style={{ width: '35%' }}>
                      <Label for="shopifyAPIShopName">
                        Web address<div className="mandatory">*</div>
                      </Label>
                      <Input
                        name="shopifyAPIShopName"
                        id="shopifyAPIShopName"
                        type="text"
                        placeholder=""
                        value={shopifyAPIShopName}
                        style={{ width: '100%' }}
                        onChange={this.handleChangeAPI}
                      >
                        {apiKey || null}
                      </Input>
                    </div>

                    <Button
                      style={{ top: -2 }}
                      disabled={showNoPermission}
                      className="company-api-button custom-modal-button"
                      color="primary"
                      onClick={this.changeShopifyAPI}
                      data-tip
                      data-for='confirmButton'
                      for="confirmButton"
                    >
                      Confirm
                      {(processing) ? (
                        <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                      ) : (null)}
                    </Button>

                    <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='confirmButton'>
                      <span>{apiTooltips.apiTabConfirm ? apiTooltips.apiTabConfirm.value : ''}</span>
                    </ReactTooltip>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="woocommerce">
                {!!changeAPIError ? (<Alert color="danger"> {changeAPIError} </Alert>) : null}

                <Row style={{ marginTop: 5 }}>
                  <Col>
                    <div className="company-api-input" style={{ position: 'relative', width: '35%', marginRight: 10 }}>

                      <Label for="woocommerceConsumerKey">
                        Consumer Key<div className="mandatory">*</div>
                      </Label>
                      <Input
                        name="woocommerceConsumerKey"
                        id="woocommerceConsumerKey"
                        type={show ? 'text' : 'password'}
                        placeholder=""
                        value={woocommerceConsumerKey}
                        style={{ width: '100%' }}
                        onChange={this.handleChangeAPI}
                      >
                        {apiKey || null}
                      </Input>
                      {show ? (
                        <Eye style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                      ) : (
                        <EyeOff style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow} />
                      )}
                    </div>

                    <div className="company-api-input" style={{ position: 'relative', width: '35%', marginRight: 10 }}>
                      <Label for="woocommerceConsumerSecret">
                        Consumer Secret<div className="mandatory">*</div>
                      </Label>
                      <Input
                        name="woocommerceConsumerSecret"
                        id="woocommerceConsumerSecret"
                        type={show2 ? 'text' : 'password'}
                        placeholder=""
                        value={woocommerceConsumerSecret}
                        style={{ width: '100%' }}
                        onChange={this.handleChangeAPI}
                      >
                        {apiKey || null}
                      </Input>
                      {show2 ? (
                        <Eye style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow2} />
                      ) : (
                        <EyeOff style={{ position: 'absolute', right: 0, bottom: 0, margin: '0.375rem 0.75rem' }} onClick={this.toggleShow2} />
                      )}
                    </div>

                    <div className="company-api-input" style={{ width: '35%' }}>
                      <Label for="shopUrl">
                        Shop URL<div className="mandatory">*</div>
                      </Label>
                      <Input
                        name="shopUrl"
                        id="shopUrl"
                        type="text"
                        placeholder=""
                        value={shopUrl}
                        style={{ width: '100%' }}
                        onChange={this.handleChangeAPI}
                      >
                        {apiKey || null}
                      </Input>
                    </div>

                    <Button
                      style={{ top: -2 }}
                      disabled={showNoPermission}
                      className="company-api-button custom-modal-button"
                      color="primary"
                      onClick={this.changeWoocommerceAPI}
                      data-tip
                      data-for='confirmButton'
                      for="confirmButton"
                    >
                      Confirm
                      {(processing) ? (
                        <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                      ) : (null)}
                    </Button>

                    <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='confirmButton'>
                      <span>{apiTooltips.apiTabConfirm ? apiTooltips.apiTabConfirm.value : ''}</span>
                    </ReactTooltip>
                  </Col>
                </Row>
              </TabPane>
            </TabContent> */}


            <Modal size="sm" isOpen={showConfirmModal} toggle={this.closeConfirmModal}>
              <ModalHeader toggle={this.closeConfirmModal}>
                <Button clasName="custom-modal-button" color="primary" onClick={this.approveConfirmModal}>
                  Confirm change
                </Button>
              </ModalHeader>
            </Modal>
          </div>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  apiKey: state.company.apiKey || '',
  roles: state.users.companiesRoles || {},
//  companyLinkedUsers: state.users.companyLinkedUsers || {},
  adminsRoles: state.admin.adminsRoles || {},
  apiTooltips: state.contentManagement.apiTooltips || {},
  activeAPI: state.company.activeAPI || 'shopify',
  adminViewAsCompany: state.admin.adminViewAsCompany || null,
});

const mapDispatchToProps = {
  fetchCompanyApiKey: getCompanyApiKey,

  fetchAPITooltips: getAPITooltips,

  fetchLinkedAPIs: getLinkedAPIs,
  linkedAPIupdate: updateLinkedAPI,
  linkedAPIAdd: addLinkedAPI,
  linkedAPIRemove: removeLinkedAPI,
  connectShopify: connectShopifyApp,
  wooTestAndSave: testAndSaveWoocommerce,

  fetchLinkedCompanyUsers: getLinkedCompanyUsers,
  createLinkedUser: createLinkedCompanyUser,
  createLinkedUserAdmin: createLinkedCompanyUserAdmin,
  deleteLinkedUser: deleteLinkedCompanyUser,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LinkedCompaniesAPIs));
